import React from 'react';

const About = () => {
    return (
        <div>
            <h1>About</h1>
            <p>Lorem Ipsum...</p>
        </div>
    );
}
export default About;